import { stepinAuthInstance } from '@/apis/types/stepinAuth';

const { GET } = stepinAuthInstance;

export const getBusinessAuthority = async (businessAccountId: string) => {
	const { data: authority } = await GET('/auth/business/authority', {
		headers: {
			BUSINESS: businessAccountId,
		},
	});
	return authority;
};
